import { render } from "./QuizType8.vue?vue&type=template&id=b2f7b8cc&scoped=true"
import script from "./QuizType8.vue?vue&type=script&lang=js"
export * from "./QuizType8.vue?vue&type=script&lang=js"

import "./QuizType8.vue?vue&type=style&index=0&id=b2f7b8cc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2f7b8cc"]])

export default __exports__